module.exports = __webpack_public_path__ + "static/fonts/fa-regular-400.54f142e.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/webfonts/fa-regular-400.ttf
// module id = hiYv
// module chunks = 0